export const environment = {
  env: 'production',
  production: true,
  // TODO: remove if it will be confirmed that this option is unnecessary
  // apiUrl: 'https://fms2.7peak.com',
  apiUrl: '',
  enabledLanguages: ['en', 'pl'],
  defaultLanguage: 'en',
  sentryDsn: 'https://abfd320d7097543503314cb5bc30d37e@o67724.ingest.us.sentry.io/4510351470493696',
};
